if (!customElements.get('collection-product-card')) {
class CollectionProductCard extends HTMLElement {
  constructor() {
    super();

    this.SELECTORS = {
      addToCartBtn: '.js-collection-card-atc',
      cartDrawer: 'cart-drawer',
      builder: '[data-collection-builder]',
      gifts: '[data-collection-card-gifts]',
      qty: '[data-collection-card-qty]',
      qtyValue: '[data-collection-card-qty-value]',
      qtyMinus: '[data-collection-card-qty-minus]',
      qtyPlus: '[data-collection-card-qty-plus]',
      priceRoot: '[data-collection-card-price]',
      priceCompare: '[data-collection-card-compare]',
      priceCurrent: '[data-collection-card-current]',
    };

    this.CLASSES = {
      loading: 'is-loading',
    };

    this.loadingText = 'Mixing Your Magna...';
    this.endpoints = {
      cart: '/cart/add.js',
      checkout: '/cart/checkout',
    };

    this.builderQty = 0;
  }

  connectedCallback() {
    this.button = this.querySelector(this.SELECTORS.addToCartBtn);
    this.qtyRoot = this.querySelector(this.SELECTORS.qty);
    this.qtyValue = this.querySelector(this.SELECTORS.qtyValue);
    this.qtyMinus = this.querySelector(this.SELECTORS.qtyMinus);
    this.qtyPlus = this.querySelector(this.SELECTORS.qtyPlus);
    this.priceRoot = this.querySelector(this.SELECTORS.priceRoot);
    this.priceCompare = this.querySelector(this.SELECTORS.priceCompare);
    this.priceCurrent = this.querySelector(this.SELECTORS.priceCurrent);
    this.quickShopTriggers = this.querySelectorAll('[data-collection-quick-shop-open]');

    this.onClick = (event) => this.handleAddToCartClick(event);
    this.onQtyMinus = (event) => this.handleQtyMinus(event);
    this.onQtyPlus = (event) => this.handleQtyPlus(event);
    this.onBuilderChange = (event) => this.syncFromBuilder(event);
    this.onQuickShopOpen = (event) => this.handleQuickShopOpen(event);
    this.onQuickShopKeydown = (event) => this.handleQuickShopKeydown(event);

    this.quickShopTriggers.forEach((trigger) => {
      trigger.addEventListener('click', this.onQuickShopOpen);
      trigger.addEventListener('keydown', this.onQuickShopKeydown);
    });

    if (this.builderPresent) {
      this.button?.addEventListener('click', this.onClick);
      this.qtyMinus?.addEventListener('click', this.onQtyMinus);
      this.qtyPlus?.addEventListener('click', this.onQtyPlus);
      document.addEventListener('collection-builder:change', this.onBuilderChange);
      this.syncFromBuilder();
      return;
    }

    if (this.qtyRoot) this.qtyRoot.hidden = true;
    if (!this.button) return;
    this.button.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
    this.qtyMinus?.removeEventListener('click', this.onQtyMinus);
    this.qtyPlus?.removeEventListener('click', this.onQtyPlus);
    document.removeEventListener('collection-builder:change', this.onBuilderChange);
    this.quickShopTriggers?.forEach((trigger) => {
      trigger.removeEventListener('click', this.onQuickShopOpen);
      trigger.removeEventListener('keydown', this.onQuickShopKeydown);
    });
  }

  handleQuickShopKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    this.handleQuickShopOpen(event);
  }

  handleQuickShopOpen(event) {
    if (event) event.preventDefault();
    if (!this.quickShopEnabled) return;

    const category = this.categoryPayload;
    document.dispatchEvent(
      new CustomEvent('collection-quick-shop:open', {
        detail: {
          variantId: this.variantId,
          productId: this.productId,
          title: this.productTitle,
          image: this.productImage,
          imageLarge: this.productImageLarge || this.productImage,
          description: this.productDescription,
          badgeText: this.badgeText,
          badgeBg: this.badgeBg,
          badgeColor: this.badgeColor,
          categoryId: this.categoryId || category.categoryId || '',
          otpPrice: this.otpPrice || category.otpPrice || '',
          subPrice: this.subPrice || category.subPrice || '',
          otpCents: this.otpCents || category.otpCents || 0,
          subCents: this.subCents || category.subCents || 0,
          sellingPlanId: this.sellingPlanId || category.sellingPlanId || '',
          offerPropertyEnabled:
            this.offerPropertyEnabled || Boolean(category.offerPropertyEnabled),
          offerPropertyValue: this.offerPropertyValue || category.offerPropertyValue || '',
          discountTiers: category.discountTiers || '',
          freeGifts: this.freeGiftsPayload.length
            ? this.freeGiftsPayload
            : category.freeGifts || [],
          preorder: this.isPreorder,
          preorderShipDate: this.preorderShipDate,
          preorderMsg: this.preorderMsg,
        },
      }),
    );
  }

  handleQtyPlus(event) {
    if (event) event.preventDefault();
    this.quickAddToBuilder();
  }

  handleQtyMinus(event) {
    if (event) event.preventDefault();
    if (this.builderQty < 1) return;
    document.dispatchEvent(
      new CustomEvent('collection-builder:remove', {
        detail: { variantId: this.variantId },
      }),
    );
  }

  setQtyMode(active) {
    if (!this.qtyRoot || !this.button) return;
    this.button.hidden = active;
    this.qtyRoot.hidden = !active;
  }

  syncFromBuilder(event) {
    const builder = document.querySelector(this.SELECTORS.builder);
    const detail = event?.detail || {};
    const items = Array.isArray(detail.items) ? detail.items : builder?.items || [];
    const subscribe =
      typeof detail.subscribe === 'boolean' ? detail.subscribe : builder?.subscribe !== false;

    this.syncQty(items);
    this.syncPrices(items, subscribe);
  }

  syncQty(items) {
    if (!this.qtyRoot) return;
    const variantId = Number(this.variantId);
    this.builderQty = items.filter((item) => Number(item.variantId) === variantId).length;
    if (this.qtyValue) this.qtyValue.textContent = String(this.builderQty);
    if (this.qtyMinus) this.qtyMinus.disabled = false;
    this.setQtyMode(this.builderQty > 0);
  }

  syncPrices(items, subscribe) {
    if (!this.priceCurrent) return;

    const category = this.categoryPayload;
    const otpCents = this.parseMoneyToCents(
      this.otpPrice || category.otpPrice,
      Number(this.otpCents) || Number(category.otpCents) || 0,
    );
    const subCents = this.parseMoneyToCents(
      this.subPrice || category.subPrice,
      Number(this.subCents) || Number(category.subCents) || 0,
    );
    const tiers = this.parseTiers(category.discountTiers);
    const categoryId = String(this.categoryId || category.categoryId || '');
    const categoryCount = items.filter((item) => String(item.categoryId || '') === categoryId).length;

    if (!subscribe) {
      this.setCardPrice(otpCents, null);
      return;
    }

    // Show unit price for the *next* box in this category (count + 1)
    const nextQty = categoryCount + 1;
    const amountOff = this.resolveTierAmount(tiers, nextQty);
    let unitCents = subCents || otpCents;
    if (amountOff != null && otpCents > 0) {
      unitCents = Math.max(0, otpCents - Math.round(parseFloat(amountOff) * 100));
    }

    this.setCardPrice(unitCents, otpCents > unitCents ? otpCents : null);
  }

  setCardPrice(currentCents, compareCents) {
    const currentLabel = this.formatMoney(currentCents);
    this.priceCurrent.textContent = currentLabel;

    if (this.priceCompare) {
      if (compareCents != null && compareCents > currentCents) {
        this.priceCompare.hidden = false;
        this.priceCompare.textContent = this.formatMoney(compareCents);
        if (this.priceRoot) {
          this.priceRoot.setAttribute(
            'aria-label',
            `${currentLabel} (was ${this.formatMoney(compareCents)})`,
          );
        }
      } else {
        this.priceCompare.hidden = true;
        this.priceCompare.textContent = '';
        if (this.priceRoot) this.priceRoot.setAttribute('aria-label', currentLabel);
      }
    }
  }

  parseMoneyToCents(value, fallback = 0) {
    if (value == null || value === '') return fallback;
    if (typeof value === 'number') return Math.round(value);
    const cleaned = String(value).replace(/[^0-9.]/g, '');
    if (!cleaned) return fallback;
    return Math.round(parseFloat(cleaned) * 100);
  }

  formatMoney(cents) {
    const amount = Number(cents) / 100;
    if (!Number.isFinite(amount)) return '$0';
    if (Number.isInteger(amount)) return `$${amount}`;
    return `$${amount.toFixed(2)}`;
  }

  parseTiers(value) {
    if (Array.isArray(value)) {
      return value
        .map((tier) => ({
          minQty: Number(tier.minQty),
          amount: Number(tier.amount ?? tier.pct),
        }))
        .filter((tier) => Number.isFinite(tier.minQty) && Number.isFinite(tier.amount));
    }

    if (!value || typeof value !== 'string') return [];

    const lines = value
      .split(/\n|;/)
      .map((line) => line.trim())
      .filter(Boolean);

    const tiers = [];
    let autoQty = 1;

    for (const line of lines) {
      if (line.includes(':')) {
        const colon = line.indexOf(':');
        const minQty = Number(String(line.slice(0, colon)).trim());
        const amount = Number(
          String(line.slice(colon + 1))
            .trim()
            .replace(',', '.'),
        );
        if (Number.isFinite(minQty) && Number.isFinite(amount)) {
          tiers.push({ minQty, amount });
        }
        continue;
      }

      const amount = Number(String(line).replace(',', '.'));
      if (Number.isFinite(amount)) {
        tiers.push({ minQty: autoQty, amount });
        autoQty += 1;
      }
    }

    return tiers;
  }

  resolveTierAmount(tiers, count) {
    if (!Array.isArray(tiers) || !tiers.length || !count) return null;
    const sorted = [...tiers].sort((a, b) => a.minQty - b.minQty);
    const zeroIndexed = sorted.some((tier) => tier.minQty === 0);
    let matched = null;
    for (const tier of sorted) {
      const hits = zeroIndexed ? count > tier.minQty : count >= tier.minQty;
      if (hits) matched = tier.amount ?? tier.pct;
    }
    return matched;
  }

  async handleAddToCartClick(event) {
    if (event) event.preventDefault();
    if (!this.button || this.button.disabled) return;

    if (this.builderPresent) {
      this.quickAddToBuilder();
      return;
    }

    const oldBtnText = this.button.innerText;

    try {
      this.button.classList.add(this.CLASSES.loading);
      this.button.setAttribute('disabled', 'true');
      this.button.innerText = this.loadingText;

      const $cartDrawer = document.querySelector(this.SELECTORS.cartDrawer);
      const sections = $cartDrawer ? $cartDrawer.getSectionsToRender().map((section) => section.id) : [];
      let items = this.getItems();

      if (this.addToCartType === 'checkout' && typeof window.clearCart === 'function') {
        await window.clearCart();
      }

      items = await this.addFreeGiftsItems(items);

      const response = await fetch(this.endpoints.cart, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items,
          sections,
        }),
      });

      if (!response.ok) {
        throw new Error('There was a problem with the request');
      }

      if (window.location.host.includes('drinkmagna') && window.dataLayer) {
        window.dataLayer.push({
          event: 'add_to_cart',
          items,
        });
      }

      const json = await response.json();

      if (this.addToCartType === 'drawer' && $cartDrawer) {
        $cartDrawer.renderContents(json);
      } else if (this.addToCartType === 'checkout') {
        document.location.href = this.endpoints.checkout;
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      this.button.innerText = oldBtnText;
      this.button.classList.remove(this.CLASSES.loading);
      this.button.removeAttribute('disabled');
    }
  }

  quickAddToBuilder() {
    const category = this.categoryPayload;
    document.dispatchEvent(
      new CustomEvent('collection-builder:add', {
        detail: {
          variantId: this.variantId,
          productId: this.productId,
          title: this.productTitle,
          image: this.productImage,
          categoryId: this.categoryId || category.categoryId || '',
          otpPrice: this.otpPrice || category.otpPrice || '',
          subPrice: this.subPrice || category.subPrice || '',
          otpCents: this.otpCents || category.otpCents || 0,
          subCents: this.subCents || category.subCents || 0,
          sellingPlanId: this.sellingPlanId || category.sellingPlanId || '',
          offerPropertyEnabled:
            this.offerPropertyEnabled || Boolean(category.offerPropertyEnabled),
          offerPropertyValue: this.offerPropertyValue || category.offerPropertyValue || '',
          discountTiers: category.discountTiers || '',
          freeGifts: this.freeGiftsPayload.length
            ? this.freeGiftsPayload
            : category.freeGifts || [],
          preorder: this.isPreorder,
          preorderShipDate: this.preorderShipDate,
        },
      }),
    );
  }

  getItems() {
    const item = {
      id: Number(this.variantId),
      quantity: this.quantity,
    };

    if (this.sellingPlanId) {
      item.selling_plan = this.sellingPlanId;
    }

    const properties = {};
    if (this.offerPropertyEnabled && this.offerPropertyValue && this.sellingPlanId) {
      properties._offer = this.offerPropertyValue;
    }
    const preorderProperty = this.preorderPropertyValue;
    if (preorderProperty) {
      properties.PREORDER = preorderProperty;
    }
    if (Object.keys(properties).length) {
      item.properties = properties;
    }

    return [item];
  }

  async addFreeGiftsItems(items) {
    if (!this.freeGiftsEnabled) return items;

    const giftIds = this.starterKitFreeIds.length > 0 ? this.starterKitFreeIds : this.freeGiftIds;
    if (!giftIds.length) return items;

    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    const existingIds = new Set(cart.items.map((item) => item.id));

    for (const productId of giftIds) {
      if (existingIds.has(Number(productId))) continue;
      items.push({
        id: productId,
        quantity: 1,
        properties: {
          _offer: 'FREE GIFT',
        },
      });
    }

    return items;
  }

  parseIdList(value) {
    if (!value) return [];
    return value
      .split(',')
      .map((id) => Number(id.trim()))
      .filter((id) => Boolean(id));
  }

  get builderPresent() {
    return Boolean(document.querySelector(this.SELECTORS.builder));
  }

  get addToCartType() {
    return this.getAttribute('add-to-cart-type') || 'drawer';
  }

  get variantId() {
    return this.getAttribute('variant-id');
  }

  get productId() {
    return this.getAttribute('product-id');
  }

  get productTitle() {
    return this.getAttribute('product-title') || '';
  }

  get productImage() {
    return this.getAttribute('product-image') || '';
  }

  get productImageLarge() {
    return this.getAttribute('product-image-large') || '';
  }

  get productDescription() {
    return this.getAttribute('product-description') || '';
  }

  get badgeText() {
    return this.getAttribute('badge-text') || '';
  }

  get badgeBg() {
    return this.getAttribute('badge-bg') || '';
  }

  get badgeColor() {
    return this.getAttribute('badge-color') || '';
  }

  get quickShopEnabled() {
    return this.getAttribute('enable-quick-shop') === 'true';
  }

  get categoryId() {
    return this.getAttribute('category-id') || '';
  }

  get otpPrice() {
    return this.getAttribute('otp-price') || '';
  }

  get subPrice() {
    return this.getAttribute('sub-price') || '';
  }

  get otpCents() {
    return Number(this.getAttribute('otp-cents') || 0);
  }

  get subCents() {
    return Number(this.getAttribute('sub-cents') || 0);
  }

  get freeGiftsPayload() {
    const node = this.querySelector(this.SELECTORS.gifts);
    if (!node) return [];
    try {
      const parsed = JSON.parse(node.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  get categoryPayload() {
    const group = this.closest('[data-collection-group]');
    const node = group?.querySelector('[data-collection-builder-category]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent) || {};
    } catch (error) {
      return {};
    }
  }

  get quantity() {
    return Number(this.getAttribute('quantity') || 1);
  }

  get sellingPlanId() {
    return this.getAttribute('selling-plan-id') || '';
  }

  get offerPropertyEnabled() {
    return this.getAttribute('offer-property-enabled') === 'true';
  }

  get offerPropertyValue() {
    return this.getAttribute('offer-property-value') || '';
  }

  get freeGiftsEnabled() {
    return this.getAttribute('free-gifts-enabled') === 'true';
  }

  get freeGiftIds() {
    return this.parseIdList(this.getAttribute('free-gifts-products-ids'));
  }

  get starterKitFreeIds() {
    return this.parseIdList(this.getAttribute('starter-kit-free-ids'));
  }

  get isPreorder() {
    return this.getAttribute('data-preorder') === 'true';
  }

  get preorderShipDate() {
    return this.getAttribute('data-ship-date') || '';
  }

  get preorderMsg() {
    return this.getAttribute('data-preorder-msg') || '';
  }

  get preorderPropertyValue() {
    if (!this.isPreorder) return '';
    const raw = this.preorderShipDate.trim();
    if (!raw) return 'PREORDER';
    // "Ships by May 25" → "SHIPS BY MAY 25TH"
    const parts = raw.split(/\s+/);
    const day = parts[parts.length - 1];
    const dayNum = parseInt(day, 10);
    if (!Number.isNaN(dayNum)) {
      parts[parts.length - 1] = `${dayNum}${this.getOrdinal(dayNum)}`;
    }
    return parts.join(' ').toUpperCase();
  }

  getOrdinal(day) {
    const n = parseInt(day, 10);
    if (n > 3 && n < 21) return 'th';
    switch (n % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }
}

customElements.define('collection-product-card', CollectionProductCard);

if (!window.__ctrCollectionQuickShopCardDelegation) {
  window.__ctrCollectionQuickShopCardDelegation = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-collection-quick-shop-open]');
    if (!trigger) return;
    const card = trigger.closest('collection-product-card');
    if (!card || typeof card.handleQuickShopOpen !== 'function') return;
    card.handleQuickShopOpen(event);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const trigger = event.target.closest('[data-collection-quick-shop-open]');
    if (!trigger) return;
    const card = trigger.closest('collection-product-card');
    if (!card || typeof card.handleQuickShopOpen !== 'function') return;
    event.preventDefault();
    card.handleQuickShopOpen(event);
  });
}
}
